<template>
    <div class="header flex-align flex">
        <div class="header flex-align flex" id="headerAside">
            <div class="header-center">
                <div class="flex">
                    <div class="flex-align flex">
<!--                        <img width="30" height="30" src="../assets/image/smallLogo.png" class="login-img" alt/>-->
                        <img width="30" height="30" src="../assets/image/logo.png" class="login-img" alt/>
                        <span class="login-title">
                            {{platformName}}
                        </span>
                    </div>
                    <div class="asideBox">
<!--                        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"-->
<!--                                 @select="handleSelect">-->
<!--                            <el-menu-item v-for="(i,j) in asideData"-->
<!--                                          :key="j" :index="i.pageRouter">-->
<!--                                {{i.pageName}}-->
<!--                            </el-menu-item>-->
<!--                        </el-menu>-->
                        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                            <!--模块-->
                            <template v-for="(item,index) in this.$store.state.permissionList">
                                <!--模块（有子菜单）-->

                                <el-submenu v-if="item.childrenFunctionList && item.childrenFunctionList.length"
                                            :index="item.urlRouter" :key="index" :disabled="!item.hasPermission">
                                    <template slot="title"><span>{{$t(item.urlRouter)}}</span></template>

                                    <!-- 一级菜单 -->
                                    <template v-for="(itemChild,indexChild) in item.childrenFunctionList">
                                        <!-- 一级菜单（有子菜单） -->
                                        <el-submenu v-if="itemChild.childrenFunctionList && itemChild.childrenFunctionList.length"
                                                    :index="itemChild.urlRouter" :key="indexChild" :disabled="!itemChild.hasPermission">
                                            <template slot="title">
                                                <span class="titleSecond">{{$t(itemChild.urlRouter)}}</span></template>

                                            <!-- 二级菜单 -->
                                            <el-menu-item v-for="(itemChild_Child,indexChild_Child) in itemChild.childrenFunctionList"
                                                          :index="itemChild_Child.urlRouter" :key="indexChild_Child" :disabled="!itemChild_Child.hasPermission">
                                                <span slot="title">{{$t(itemChild_Child.urlRouter)}}</span>
                                            </el-menu-item>
                                        </el-submenu>

                                        <!-- 一级菜单（无子菜单） -->
                                        <el-menu-item v-else :index="itemChild.urlRouter" :key="indexChild" :disabled="!itemChild.hasPermission">
                                            <span slot="title" class="titleSecond">{{$t(itemChild.urlRouter)}}</span>
                                        </el-menu-item>
                                    </template>
                                </el-submenu>

                                <!--模块（无子菜单）-->
                                <el-menu-item v-else :index="item.urlRouter" :key="index" :disabled="!item.hasPermission">
                                    <span slot="title">{{$t(item.urlRouter)}}</span>
                                </el-menu-item>
                            </template>
                        </el-menu>

<!--                        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">-->
<!--                            &lt;!&ndash;首页&ndash;&gt;-->
<!--                            <el-menu-item index="/homePage">{{$t("header.home")}}</el-menu-item>-->
<!--                            &lt;!&ndash;我要下单&ndash;&gt;-->
<!--                            <el-menu-item index="/order">{{$t("header.order")}}</el-menu-item>-->
<!--                            &lt;!&ndash;订舱查询&ndash;&gt;-->
<!--                            <el-menu-item index="/booking">{{$t("header.booking")}}</el-menu-item>-->
<!--                            &lt;!&ndash;提单信息&ndash;&gt;-->
<!--                            <el-submenu index="/billOfLading">-->
<!--                                <template slot="title">{{$t("header.lading")}}</template>-->
<!--                                &lt;!&ndash;提单查询&ndash;&gt;-->
<!--                                <el-menu-item index="/billOfLading">-->
<!--                                    <span class="titleSecond">{{$t("header.billLading")}}</span>-->
<!--                                </el-menu-item>-->
<!--                                &lt;!&ndash;拆并单&ndash;&gt;-->
<!--                                <el-submenu index="/spliteBill">-->
<!--                                    <template slot="title">-->
<!--                                        <span class="titleSecond">{{$t("header.spliteAndCombine")}}</span></template>-->
<!--                                    &lt;!&ndash;拆单&ndash;&gt;-->
<!--                                    <el-menu-item index="/spliteBill">{{$t("header.spliteBill")}}</el-menu-item>-->
<!--                                    &lt;!&ndash;并单&ndash;&gt;-->
<!--                                    <el-menu-item index="/combineBill">{{$t("header.combineBill")}}</el-menu-item>-->
<!--                                </el-submenu>-->
<!--                            </el-submenu>-->
<!--                            &lt;!&ndash;跟踪&ndash;&gt;-->
<!--                            <el-submenu index="/track">-->
<!--                                <template slot="title">{{$t("header.track")}}</template>-->
<!--                                &lt;!&ndash;货物跟踪&ndash;&gt;-->
<!--                                <el-menu-item index="/cargoTrack">-->
<!--                                    <span class="titleSecond">{{$t("header.cargoTrack")}}</span></el-menu-item>-->
<!--                                &lt;!&ndash;修箱报价查询&ndash;&gt;-->
<!--                                <el-menu-item index="/repairTrack">-->
<!--                                    <span class="titleSecond">{{$t("header.repairTrack")}}</span></el-menu-item>-->
<!--&lt;!&ndash;                              &lt;!&ndash;FreeTime查询&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                              <el-menu-item index="/freeTime">&ndash;&gt;-->
<!--&lt;!&ndash;                                <span class="titleSecond">{{$t("header.freeTime")}}</span></el-menu-item>&ndash;&gt;-->
<!--                            </el-submenu>-->
<!--                            &lt;!&ndash;箱管&ndash;&gt;-->
<!--                            <el-submenu index="/equipment">-->
<!--                                <template slot="title">{{$t("header.equipment")}}</template>-->
<!--                                &lt;!&ndash;修箱&ndash;&gt;-->
<!--                                <el-submenu index="/equipment/repair">-->
<!--                                    <template slot="title">-->
<!--                                        <span class="titleSecond">{{$t("header.repair")}}</span></template>-->
<!--                                    <el-menu-item index="/equipment/repair/estimate">{{$t("header.estimate")}}</el-menu-item>-->
<!--                                    <el-menu-item index="/equipment/repair/thirdPartyCharge">{{$t("header.thirdPartyCharge")}}</el-menu-item>-->
<!--                                </el-submenu>-->
<!--                            </el-submenu>-->
<!--                            &lt;!&ndash;对账&ndash;&gt;-->
<!--                            <el-submenu index="/reconciliation">-->
<!--                                <template slot="title">{{$t("header.reconciliation")}}</template>-->
<!--                                &lt;!&ndash;费用查询&ndash;&gt;-->
<!--                                <el-menu-item index="/confirmFreight">-->
<!--                                    <span class="titleSecond">{{$t("header.confirmFreight")}}</span></el-menu-item>-->
<!--                                &lt;!&ndash;对账单管理&ndash;&gt;-->
<!--                                <el-menu-item index="/billsManagement">-->
<!--                                    <span class="titleSecond">{{$t("header.billManagement")}}</span></el-menu-item>-->
<!--                                &lt;!&ndash;发票管理&ndash;&gt;-->
<!--                                <el-menu-item index="/invoiceApplication">-->
<!--                                    <span class="titleSecond">{{$t("header.invoiceManagement")}}</span></el-menu-item>-->
<!--                            </el-submenu>-->
<!--                        </el-menu>-->
<!--                        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">-->
<!--                            &lt;!&ndash;用户中心&ndash;&gt;-->
<!--                            <el-submenu index="/userCenter">-->
<!--                                <template slot="title">{{$t("header.userCenter")}}</template>-->
<!--                                &lt;!&ndash;个人信息&ndash;&gt;-->
<!--                                <el-menu-item index="/personalInfo">-->
<!--                                    <span class="titleSecond">{{$t("header.personalInformation")}}</span></el-menu-item>-->
<!--                            </el-submenu>-->
<!--                        </el-menu>-->
                    </div>
                </div>
                <div class="userBox">
                    <div class="userBox-top  flex-align flex">
                        <el-dropdown @command="logout" placement="bottom" :disabled="getLogin">
                            <el-avatar class="el-icon-my-admin" size="small"></el-avatar>
                            <el-dropdown-menu slot="dropdown" >
                                <span style="text-align: center;display:block;font-size:14px">{{userName}}</span>
<!--                                <span class="span">{{getSimplyCompanyName}}</span>-->
                                <!--退出登录-->
                                <el-dropdown-item command="out" divided>
                                    {{logoutOption}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-divider direction="vertical"></el-divider>
                        <!--语言切换-->
                        <el-dropdown @command="changeLanguage">
                            <span class="el-dropdown-link">
                                {{dropdownData[dropdownIndex]}}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(i,j) in dropdownData"
                                                  :key="j" :command="composeLanguage(i,j)">{{i}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-divider direction="vertical"></el-divider>
                        <!--当前主体显示-->
                        <div class="entity-display">
<!--                            <span class="entity-label">当前主体：</span>-->
                            <span class="entity-value">{{getCurrentEntityDisplay()}}</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        name: "headerAside",
        computed: {
            activeIndex() {
                return this.$route.path
            },
            asideData() {
                return [
                    /*首页登录*/
                    {pageName: this.$t("header.home"), pageRouter: "/homePage"},
                    /*我要下单*/
                    {pageName: this.$t("header.order"), pageRouter: "/order"},
                    /*订舱查询*/
                    {pageName: this.$t("header.booking"), pageRouter: "/booking"},
                    /*提单信息*/
                    {pageName: this.$t("header.lading"), pageRouter: "/billOfLading"},
                    /*拆单*/
                    {pageName: this.$t("header.spliteBill"), pageRouter: "/spliteBill"},
                    /*并单*/
                    {pageName: this.$t("header.combineBill"), pageRouter: "/combineBill"},
                    /*货物跟踪*/
                    {pageName: this.$t("header.track"), pageRouter: "/track"},

                ];
            },
            getLogin(){
                return this.companyName=="" ;
            },
            otherLink() {
                return this.$t("header.otherLink");
            },
            platformName() {
                return this.$t("header.platformName");
            },
            getSimplyCompanyName() {
                if(this.companyName == null || this.companyName === "" || this.companyName.length <= 25){
                    return this.companyName;
                }
                // 超过25字符则省略显示
                return this.companyName.substring(0, 25) + "...】";
            },
            /*退出登录按钮*/
            logoutOption() {
                return this.$t("header.logout");
            }
        },
        data() {
            return {
                dropdownData: ["中文", "English"],
                dropdownIndex: 0,
                lang: "zh",
                userName: "",
                companyName: "",
                custContactsDTO:{
                    companyCode:"",
                    companyNameCn:"",
                    companyName:"",
                },
            };
        },
        methods: {
            /************************************ 顶部菜单栏点击事件【跳转页面】 ************************************/
            handleSelect(key) {
                this.$router.push({
                    path: key,
                    query:{
                        custContactsDTO:this.custContactsDTO,
                    }
                });


            },
            /************************************ 中英文切换事件 ************************************/
            changeLanguage(e) {
                if (e.lan == "English") {
                    this.lang = "en";
                    this.dropdownIndex = 1;
                } else {
                    this.lang = "zh";
                    this.dropdownIndex = 0;
                }
                localStorage.setItem("locale", this.lang);
                this.$i18n.locale = this.lang;
            },
            composeLanguage(item, row) {
                return {
                    lan: item,
                    row: row
                };
            },

            /************************************ 退出登录事件 ************************************/
            logout(command) {
                if (!sessionStorage.getItem("ACCOUNT_CODE")
                        || sessionStorage.getItem("ACCOUNT_CODE") === ""
                        || command !== "out") {
                    this.showMessage(false, this.$t("message.logoutMsg"), "warning");
                } else {
                    //调用后端退出登录API
                    this.axios({
                        method: 'post',
                        url: '/api/user/logout',
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        if (response.data.backCode === "200") {
                            // 清空session中的账号信息,并跳转到首页登录
                            sessionStorage.setItem("ACCOUNT_CODE", "");
                            sessionStorage.setItem("COMPANY_CODE", "");
                            this.userName = this.$t("header.nonLogin");
                            this.companyName = "";
                            this.updateSessionPermissionData();
                            this.$router.push('/homePage');
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                }
            },

            /************************************ 获取当前登录用户信息,更新到session中 ************************************/
            getUserInfo() {
                //调用后端获取登录用户信息API
                this.axios({
                    method: 'post',
                    url: '/api/user/getLoginInfo',
                    headers: {
                        'Content-type': 'application/json',
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        this.custContactsDTO.companyCode = response.data.object.companyCode.toString();
                        this.custContactsDTO.companyName = response.data.object.companyName.toString();
                        this.custContactsDTO.companyNameCn = response.data.object.companyNameCn.toString();

                        this.userName = response.data.object.customerName.toString();
                        this.companyName = "【"+response.data.object.companyNameCn.toString()+"】";
                        sessionStorage.setItem("ACCOUNT_CODE", response.data.object.customerName == null ?
                            "" : response.data.object.customerName.toString());
                        sessionStorage.setItem("COMPANY_CODE", response.data.object.companyNameCn == null ?
                            "" : response.data.object.companyNameCn.toString());
                    } else {
                        this.userName = this.$t("header.nonLogin");
                        this.companyName = "";
                        // 获取失败,则清空session中的账号信息
                        sessionStorage.setItem("ACCOUNT_CODE", "");
                        sessionStorage.setItem("COMPANY_CODE", "");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 更新缓存中的用户权限数据
             */
            updateSessionPermissionData(){
                this.axios({
                    method: 'post',
                    url: '/api/elineFunction/getAllFunctionByLoginUser',
                    headers: {
                        'Content-type': 'application/json',
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        // 获取成功,将功能权限信息缓存到session中
                        sessionStorage.setItem("permissionList",JSON.stringify(response.data.object));
                        // 将功能权限信息缓存到vuex中
                        this.$store.state.permissionList = response.data.object;
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 获取当前主体显示名称
             */
            getCurrentEntityDisplay() {
                const entity = this.$apiUtils.getCurrentEntity();
                if (entity === "1") {
                    return "股份";
                } else if (entity === "2") {
                    return "新加坡";
                } else {
                    return "未选择";
                }
            },
        },
        mounted() {
            this.getUserInfo();
            this.lang = localStorage.getItem("locale");
            if (this.lang == "en") {
                this.dropdownIndex = 1;
            } else {
                this.dropdownIndex = 0;
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "../assets/scss/base.scss";
    @import "../assets/scss/public.scss";

    .header {
        border-bottom: 1px $colorB solid;
        height: 95px;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999;
        background: $colorA;
    }

    .header-center {
        justify-content: space-between;
        display: flex;
        align-items: center;
        width: 1248px;
        margin: auto;
    }

    .login-img {
        width: 52px;
        /*height: 36px;*/
        height: 52px;
    }

    .login-title {
        color: $colorC;
        letter-spacing: 3px;
        margin-left: 8px;
        font-size: $fontE;
        width: 150px;
    }

    .asideBox {
        margin-left: 60px;

        /deep/ .el-menu-item.is-active {
            border-bottom: 4px solid $colorC;
            color: $colorC !important;
        }

        /deep/ .el-menu {
            border: none;
        }

        /deep/ .el-menu-item {
            height: 40px;
            line-height: 40px;
            font-size: $fontE;
            font-weight: 600;
        }

        /deep/ .el-submenu.is-active {
            border-bottom: 4px solid $colorC;
            color: $colorC !important;
        }

        /deep/ .el-submenu__title {
            height: 40px;
            line-height: 40px;
            font-size: $fontE;
            font-weight: 600;
        }

        /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
            height: 40px;
            line-height: 40px;
            border-bottom: 2px solid transparent;
            color: #909399;
        }

        // 控制下拉菜单鼠标悬停时显示黑色
        /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title:hover{
            color: #303133;
        }
    }

    .titleSecond {
        color: #BC1920;
        font-weight: bold
    }

    .userBox {
        .userBox-bottom {
            margin-top: 10px;
            font-size: 13px;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            img {
                width: 24px;
                height: 24px;
                margin-right: 6px;
            }

            span {
                line-height: 24px;
                color: $colorF;
            }
        }

        .userBox-top {
            margin-top: 10px;

            .span {
                font-size: $fontE;
                color: $colorF;
            }
        }

        .entity-display {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 15px 10px;
            background: rgba(254, 180, 220, .1);
            border: 1.5px solid rgba(188, 25, 32, .3);
            border-radius: 4px;
            min-width: 80px;

            .entity-label {
                font-size: 12px;
                color: #666;
                margin-bottom: 2px;
                line-height: 1;
            }

            .entity-value {
                font-size: 14px;
                font-weight: 600;
                color: #bc1920;
                line-height: 1;
            }
        }
    }

    .el-icon-my-admin {
        background: url('../assets/image/icon/admin.svg') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }
    .el-icon-my-admin :before {
        content: '替';
        font-size: 16px;
        visibility: hidden;
    }
</style>